import { BRUNCH_HIGHLIGHTS } from "@/data/menu";
import { HERO_IMAGES, LOGO_LIGHT } from "@/lib/constants";

export default function Brunch() {
  return (
    <section
      id="brunch"
      data-testid="brunch-section"
      className="bg-[#FDFBF7] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-center">
          {/* Left: text */}
          <div className="col-span-12 md:col-span-5 md:order-1 order-2">
            <p className="font-mono-accent text-[12px] text-[#7A2021] mb-5">
              — Sundays & Saturdays · 10 → 14
            </p>
            <h2
              data-testid="brunch-heading"
              className="font-serif-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight text-[#1A1713]"
            >
              Brunch at <br />
              <em className="text-[#7A2021]">Ladiosa's.</em>
            </h2>
            <p className="mt-8 text-[#1A1713]/80 text-base md:text-lg leading-relaxed">
              Indulgent, broad, a touch theatrical. From lobster macaroni cheese
              and eggs benedict to the salted caramel banana waffle — book a long
              table and stay through the afternoon.
            </p>
            <p className="mt-5 text-[#5C5449] text-sm leading-relaxed">
              Our mixologists conjure cocktails table-side, and on Sundays a
              resident caricaturist captures friends and family in illustrated
              form.
            </p>

            <ul className="mt-10 space-y-3 border-t border-[#E4DECD] pt-6">
              {BRUNCH_HIGHLIGHTS.map((b) => (
                <li
                  key={b.name}
                  data-testid="brunch-highlight-row"
                  className="border-b border-[#E4DECD] pb-4"
                >
                  <p className="font-serif-display text-2xl text-[#1A1713]">
                    {b.name}
                  </p>
                  <p className="text-[#5C5449] text-sm mt-1">{b.description}</p>
                </li>
              ))}
            </ul>

            <a
              href="#reserve"
              data-testid="brunch-reserve-btn"
              className="inline-block mt-10 font-mono-accent text-[13px] bg-[#1A1713] text-[#FDFBF7] px-7 py-4 hover:bg-[#7A2021] transition-colors duration-500"
            >
              Book the Brunch Table
            </a>
          </div>

          {/* Right: photo collage */}
          <div className="col-span-12 md:col-span-7 md:order-2 order-1 relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={HERO_IMAGES.brunch}
                alt="Brunch at Ladiosa's"
                className="w-full h-full object-cover hover:scale-[1.04] transition-transform duration-1000"
              />
            </div>
            <div className="absolute bottom-6 left-6 md:-bottom-10 md:-left-10 w-44 md:w-64 aspect-[3/4] overflow-hidden border-8 border-[#FDFBF7] z-10">
              <img
                src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=900&q=80"
                alt="Brunch pastries"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute top-6 right-6">
              <img src={LOGO_LIGHT} alt="Ladiosa's" className="h-20 w-auto object-contain" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
